// extracted by mini-css-extract-plugin
export default {"reset__links":"Reset_reset__links__TEjuM AuthPage_auth__links__ws-cL","reset":"Reset_reset__LvTMS"};